/* unplugin-vue-components disabled */import script from "./teacherPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./teacherPhone.vue?vue&type=script&lang=ts&setup=true"

export default script